/**
 *@file config.js
 *@version 1.0.1
 *@author wuwg
 *@createTime 2019/10/17 - 20:37
 *@updateTime 2019/10/17 - 20:37
 *@see [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 * @description    server-config.js.js ,所有服务器的url配置
 */
const dirServicePath = window.serverConfig.dirServicePath;
// 服务数据
const serverUrl = {
    login: category =>
        ({
            // 登录
            login: `${dirServicePath}/rewarduser/login`,
            // 校验token是否失效
            checkToken: `${dirServicePath}/user/checkToken`,

            rewardusergetRewardUserQcode: dirServicePath + "/wxshare/getRewardUserQcode", //程序员获取微信二维码
            rewardUserQrCodeLogin: dirServicePath + "/rewarduser/rewardUserQrCodeLogin", //程序员轮寻结果
            rewardUserWXgetCode: dirServicePath + "/phonecode/rewarduser/register", //程序员绑定微信获取验证码

            rewarduserPhonecode: dirServicePath + "/phonecode/programmer/login", //程序员登录获取验证码
            rewarduserQuickLogin: dirServicePath + "/programmer/login", //程序员手机号验证码登录
            rewarduserLogin: dirServicePath + "/rewarduser/login", //程序员账号密码登录

            rewarduserPhonecodeRegister: dirServicePath + "/phonecode/programmer/login", //程序员注册获取验证码
            rewarduserRegister: dirServicePath + "/programmer/login", //程序员注册

            rewarduserPhonecodeForgetPassword: dirServicePath + "/phonecode/rewarduser/forgetPassword", //程序员忘记密码获取验证码
            rewarduserForgetPassword: dirServicePath + "/rewarduser/forgetPassword" //程序员找回密码
        }[category]),
    common: category =>
        ({
            // 上传
            upload: `${dirServicePath}/upload/rewarduser/uploadFile`,
            // 上传身份证加水印
            uploadIdcard: `${dirServicePath}/upload/reward/idcard`,
            city: `${dirServicePath}/cnregioninfo/city`,

            getInfo: `${dirServicePath}/programmer/getProgrammerByToken`,

            saveInfo1: `${dirServicePath}/rewarduser/info/saveInfo1`,
            saveInfo2: `${dirServicePath}/rewarduser/info/saveInfo2`,
            saveInfo3: `${dirServicePath}/rewarduser/info/saveInfo3`,
            navigation: `${dirServicePath}/programmer/info/navigation`,
            deleteInfo: `${dirServicePath}/rewarduser/info/delete`,
            // 邮箱获取验证码
            emailcode: `${dirServicePath}/emailcode/auth`,
            // 银行卡列表
            selectUserBankInfo: `${dirServicePath}/rewarduser/bankinfo/selectUserBankInfo`,
            // 添加银行卡获取验证码
            insertUserBankInfo: `${dirServicePath}/phonecode/insertUserBankInfo`,
            // 添加银行卡
            insertUserBankInfoSub: `${dirServicePath}/rewarduser/bankinfo/insertUserBankInfo`,
            // 修改密码获取验证码
            forgetPasswordCode: `${dirServicePath}/phonecode/rewarduser/forgetPassword`,
            // 修改密码
            forgetPasswordSubmit: `${dirServicePath}/rewarduser/forgetPassword`,

            // 解绑银行卡获取验证码
            delCardCode: `${dirServicePath}/phonecode/deleteUserBankUserInfo`,
            // 解绑银行卡
            delCardSubmit: `${dirServicePath}/rewarduser/bankinfo/deleteUserBankUserInfo`,

            // 获取合同列表
            getDeliverContractList: `${dirServicePath}/deliver/reward/getDeliverContractList`,

            //未读消息提示
            getMessageCount: `${dirServicePath}/message/reward/getMessageCount`,

            //清除认证消息
            clearAuthCount: `${dirServicePath}/message/reward/clearAuthCount`,
            //清除面试消息
            clearDeliverCount1: `${dirServicePath}/message/reward/clearDeliverCount1`,

            //清除入职信息
            clearDeliverCount2: `${dirServicePath}/message/reward/clearDeliverCount2`,

            //提交信息
            submitInfo: `${dirServicePath}/programmer/info/submitInfo`,
            //更新工作状态
            updateWorkStatus: `${dirServicePath}/programmer/info/updateWorkStatus`,
            //实名认证
            saveIdNo: `${dirServicePath}/programmer/info/saveIdNo`,

            //获取用户信息
            programmerSaveIdNo: `${dirServicePath}/programmer/info/getInfo`,
            //获取用户信息
            uploadAvatar: `${dirServicePath}/upload/programmer/uploadAvatar`,

            //上传简历
            cvParser: `${dirServicePath}/cv/cvParser`,
            //上传简历
            updateInfo: `${dirServicePath}/programmer/info/updateInfo`,
            //修改简历
            updateCVInfo: `${dirServicePath}/programmer/info/updateCVInfo`,
            //已读认证
            readAuth: `${dirServicePath}/programmer/info/readAuth`,
            //
            //HR试题
            getQuestion: `${dirServicePath}/exam/getQuestion`,
            //HR试题提交
            submitQuestion: `${dirServicePath}/exam/submitQuestion`,
            //获取岗位测评链接
            createWrittenExam: `${dirServicePath}/exam/createWrittenExam`,
            //获取岗位测评链接
            getLastWrittenExam: `${dirServicePath}/exam/getLastWrittenExam`,

            //我的认证
            myAuth: `${dirServicePath}/programmer/info/myAuth`,
            //账号信息
            accountInfo: `${dirServicePath}/programmer/info/accountInfo`,

            // 获取基本信息
            getBaseInfo: `${dirServicePath}/programmer/info/baseInfo`,

            //简历信息
            cvInfo: `${dirServicePath}/programmer/info/cvInfo`,

            //获取实名认证结果
            getIdStatus: `${dirServicePath}/programmer/info/getIdStatus`,

            //小程序路径转链接
            getProgrammerMPIndex: `${dirServicePath}/wxshare/getProgrammerMPIndex`,

            //页面访问统计
            programmerPageVS: `${dirServicePath}/vs/programmerPageVS`,
            //修改头像
            updateAvatar: `${dirServicePath}/programmer/info/updateAvatar`,

            // 上传发票文件
            withdraw: `${dirServicePath}/upload/admin/withdraw`,

        }[category]),
    sfrz: category =>
        ({
            // 保存身份信息
            saveIdCard: `${dirServicePath}/rewarduser/info/saveIdCard`,
            // 保存教育北京
            saveJiaoyubeijing: `${dirServicePath}/rewarduser/info/saveJiaoyubeijing`,
            // 保存工作经历
            saveGongzuojingli: `${dirServicePath}/rewarduser/info/saveGongzuojingli`,
            // 保存项目经历
            saveXiangmujingli: `${dirServicePath}/rewarduser/info/saveXiangmujingli`,
            // 牛人认证上传证书
            uploadExpert: `${dirServicePath}/upload/programmer/uploadExpert`,
            // 提交牛人认证信息
            submitExpertInfo: `${dirServicePath}/programmer/info/submitExpertInfo`
        }[category]),
    home: category =>
        ({
            // 申请成为猿派供应商
            beYPGongyingshangs: `${dirServicePath}/user/beYPGongyingshang`,
            // 移除解约
            breakByGongyingshang: `${dirServicePath}/user/breakByGongyingshang`,
            // 获取信息
            getUserByToken: `${dirServicePath}/user/getUserByToken`,
            // 修改个人信息
            changeInfo: `${dirServicePath}/user/changeInfo`,
            // 首页统计
            indexStat: `${dirServicePath}/stat/gongyingshangIndexStat`,
            // 简历投递统计
            deliverStat: `${dirServicePath}/stat/gongyingshangDeliverStat`,
            //HR入职率排行
            gysRuzhiTop: `${dirServicePath}/stat/hrRuzhiTop`,
            //岗位优先级排行
            jobRuzhiTop: `${dirServicePath}/stat/gysJobRuzhiTop`,
            //聊一聊列表
            liaoyiliaoList: `${dirServicePath}/workorder/programmer/liaoyiliaoList`,
            //推荐的订单
            recommendWorkList: `${dirServicePath}/work/programmer/recommendWorkList`,
            //修改空闲状态
            updateJobWay: `${dirServicePath}/programmer/info/updateJobWay`,
            //查看工作内容
            orderInfo: `${dirServicePath}/workorder/programmer/orderInfo`,
            //取消预约
            cancelDeliver: `${dirServicePath}/workorder/programmer/cancelDeliver`,
            //获取当前预约
            getOrdering: `${dirServicePath}/workorder/programmer/getOrdering`,
            //拒绝邀请
            refuseInvite: `${dirServicePath}/workorder/programmer/refuseInvite`,
            //接受邀请
            acceptInvite: `${dirServicePath}/workorder/programmer/acceptInvite`,
            //
        }[category]),
    glygl: category =>
        ({
            // 管理员列表
            glyglSelectAdmin: `${dirServicePath}/admin/selectAdmin`,
            // 添加管理员
            glyglInsertAdmin: `${dirServicePath}/admin/insertAdmin`,
            // 重置密码
            glyglChangePwd: `${dirServicePath}/admin/changePwd`,
            // 启用、冻结
            glyglUpdateAdmin: `${dirServicePath}/admin/updateAdmin`,
            // 删除
            glyglDeleteAdmin: `${dirServicePath}/admin/deleteAdmin`
        }[category]),
    qygl: category =>
        ({
            // 企业列表
            qyglGetUserList: `${dirServicePath}/admin/user/getUserList`,
            // 添加企业
            qyglInsertUser: `${dirServicePath}/admin/user/insertUser`,
            // 重置密码
            qyglChangePwd: `${dirServicePath}/admin/user/changePwd`,
            // 启用、冻结
            qyglUpdateUser: `${dirServicePath}/admin/user/updateUser`,
            // 删除
            qyglDeleteUser: `${dirServicePath}/admin/user/deleteUser`,
            // 审核
            qyglRoleUser: `${dirServicePath}/admin/user/roleUser`,
            // 热门企业
            qyglHotQiyeList: `${dirServicePath}/admin/user/hotQiyeList`,
            // 热门供应商
            gysHotQiyeList: `${dirServicePath}/admin/user/hotGongyingshangList`,
            // 导出
            gysgetUserExcel: `${dirServicePath}/admin/user/getUserExcel`
        }[category]),
    msgl: category =>
        ({
            // // 面试列表
            // getDeliverList: `${dirServicePath}/deliver/getDeliverList`,
            // 修改状态
            updateDeliver: `${dirServicePath}/deliver/gysUpdateDeliver`,
            // 反馈记录列表
            getDeliverRecord: `${dirServicePath}/deliver/getDeliverRecord`,
            // 面试导出
            getDeliverExcel: `${dirServicePath}/deliver/getDeliverExcel`,
            //获取企业预约时段
            qiyeBookAvailable: `${dirServicePath}/deliver/qiyeBookAvailable`,
            // //确认面试时间
            //下载材料
            qiyePackageRuzhiCailiao: `${dirServicePath}/deliver/qiyePackageRuzhiCailiao`,
            // qiyeBookAvailable: `${dirServicePath}/deliver/gysUpdateDeliver`,
            // 面试日程
            qiyeMianshi: `${dirServicePath}/backlog/gongyingshangMianshi`,
            // 待办数量
            qiyeDaiBanCount: `${dirServicePath}/backlog/gongyingshangDaiBanCount`,
            //供应商确认预约
            //confirmBook: `${dirServicePath}/deliver/supplier/confirmBook`,
            // //供应商确认预约
            // qiyeDaiBanCount: `${dirServicePath}/deliver/supplier/confirmBook`,
            //供应商修改预约
            //changeBook: `${dirServicePath}/deliver/supplier/changeBook`,
            //供应商拒绝面试
            //cancelDeliver: `${dirServicePath}/deliver/supplier/cancelDeliver`,
            // 企业预约时间记录
            timeList: `${dirServicePath}/deliver/company/timeList`,
            // 获取面试列表
            getDeliverList: `${dirServicePath}/deliver/reward/getDeliverList`,
            //获取面试详情
            getDeliverById: `${dirServicePath}/deliver/reward/getDeliverById`,
            //修改面试
            changeBook: `${dirServicePath}/deliver/reward/changeBook`,
            //同意面试
            confirmBook: `${dirServicePath}/deliver/reward/confirmBook`,
            //拒绝面试
            refuseInterviewer: `${dirServicePath}/deliver/reward/refuseInterviewer`,
            //取消面试
            cancelInterviewer: `${dirServicePath}/deliver/reward/cancelInterviewer`,
            //提交材料
            submissionsDeliver: `${dirServicePath}/deliver/reward/submissions`,
            //取消入职
            refuseEnter: `${dirServicePath}/deliver/reward/refuseEnter`,

            //新版本预约面试
            yuyueOrder: `${dirServicePath}/workorder/programmer/order`,
            //获取岗位预约信息
            getOrder: `${dirServicePath}/workorder/programmer/getOrder`,
            //催办
            press: `${dirServicePath}/workorder/programmer/press`,
            //修改到岗时间
            changeDaogang: `${dirServicePath}/workorder/programmer/changeDaogang`,
            //接受面试
            acceptInterview: `${dirServicePath}/workorder/programmer/acceptInterview`,
            //取消预约
            cancelInterview: `${dirServicePath}/workorder/programmer/cancelInterview`,
            //已读
            readOrder: `${dirServicePath}/workorder/programmer/readOrder`,
            //取消订单
            cancelOrder: `${dirServicePath}/workorder/programmer/cancelOrder`,
            //接受订单
            acceptOrder: `${dirServicePath}/workorder/programmer/acceptOrder`,
            //岗位类型
            programmerWorkType: `${dirServicePath}/dictionary/programmerWorkType`,
        }[category]),
    czrz: category =>
        ({
            // 日志列表
            selectLogs: `${dirServicePath}/logs/selectLogs`
        }[category]),
    htgl: category =>
        ({
            // 合同管理
            userContractList: `${dirServicePath}/usercontract/userContractList`
        }[category]),
    mbgl: category =>
        ({
            // 模板列表
            getDictList: `${dirServicePath}/dictionary/workExperience`,
            // 模板列表
            level: `${dirServicePath}/dictionary/level`,
            // 模板列表2
            education: `${dirServicePath}/dictionary/education`,
            // 模板新增
            insertDictionary: `${dirServicePath}/dictionary/insertDictionary`,
            // 模板修改
            updateDictionary: `${dirServicePath}/dictionary/updateDictionary`,
            // 模板删除
            deleteDictionary: `${dirServicePath}/dictionary/deleteDictionary`
        }[category]),
    ddgl: category =>
        ({
            // 订单列表
            ddglselectJobOrder: `${dirServicePath}/joborder/selectJobOrder`,
            // 岗位详情
            ddgljobDetail: `${dirServicePath}/joborder/jobOrderDetail`,
            // 接受/拒绝
            ddglupdateJobOrder: `${dirServicePath}/joborder/gysUpdateJobOrder`,
            // 导出岗位
            ddglgetJobOrderExcel: `${dirServicePath}/joborder/getJobOrderExcel`,
            //设置招聘价格
            setZhaopinjia: `${dirServicePath}/joborder/setZhaopinjia`
        }[category]),
    gwgl: category =>
        ({
            //技能标签
            gwgllableList: `${dirServicePath}/dictionary/skillLabel`,
            // 岗位列表
            gwglselectJob: `${dirServicePath}/work/programmer/workList`,
            // 岗位详情
            workDetail: `${dirServicePath}/work/programmer/workDetail`,
            // 导出岗位
            gwglgetJobExcel: `${dirServicePath}/job/getJobGongyingshangExcel`,
            // 提交简历
            gwglinserDeliver: `${dirServicePath}/deliver/inserDeliverByJobOrderId`,
            // 批量提交简历
            gwgmultiDeliver: `${dirServicePath}/deliver/multiDeliverByJobOrderId`,
            //获取可分配岗位专员list
            getZhuanyuanByJob: `${dirServicePath}/job/getZhuanyuanByJob`,
            //分配专员
            fenpeiJob: `${dirServicePath}/job/fenpeiJob`,
            //获取城市列表
            city: `${dirServicePath}/cnregioninfo/city`,
            //获取技能标签
            getLableList: `${dirServicePath}/dictionary/getLableList`,
            //获取技能标签
            getResumeListByJobOrderId: `${dirServicePath}/resume/getResumeListByJobOrderId`,
            //岗位等级
            gwgldengjiList: `${dirServicePath}/dictionary/level`,
            //技能熟练度
            shuliandu: `${dirServicePath}/dictionary/shuliandu`,
            //省市
            gwglSSQList: `${dirServicePath}/cnregioninfo/pca`,
            //投递岗位
            inserDeliverByJobOrderId: `${dirServicePath}/deliver/reward/inserDeliverByJobOrderId`
        }[category]),
    jlgl: category =>
        ({
            // 字典
            getDictList: `${dirServicePath}/dictionary/education`,
            // 简历列表
            getResumeList: `${dirServicePath}/resume/getResumeList`,
            // 简历删除
            deleteResume: `${dirServicePath}/resume/deleteResume`,
            // 导出简历
            getResumeExcel: `${dirServicePath}/resume/getResumeExcel`,
            // 添加简历
            insertResume: `${dirServicePath}/resume/insertResume`,
            // 编辑简历
            updateResume: `${dirServicePath}/resume/updateResume`,
            // 批量导出简历
            qiyePackageDeliver: `${dirServicePath}/deliver/qiyePackageDeliver`,
            // 重复监测
            chongfuJiance: `${dirServicePath}/deliver/chongfuJiance`,
            // 学历监测
            xueliJiance: `${dirServicePath}/deliver/xueliJiance`,
            // 简历解析
            resumeParser: `${dirServicePath}/resume/resumeParser`,

            // 学历查询
            xuelichaxun: `${dirServicePath}/dictionary/xuelichaxun`,
            // 学校类型
            xuexiaoleixing: `${dirServicePath}/dictionary/xuexiaoleixing`,
            // 行业领域
            hangyelingyu: `${dirServicePath}/dictionary/hangyelingyu`,
            // 获取关键词
            getLabel: `${dirServicePath}/dictionary/getLabel`,

            //生成邀请码
            insertResumeInvitecode: `${dirServicePath}/resume/invite/insertResumeInvitecode`,

            //获取简历信息
            getResume: `${dirServicePath}/resumereward/getResume`,
            //提交简历信息
            updateInfo: `${dirServicePath}/rewarduser/info/updateInfo`,
            //获取岗位类型
            programmerWorkType: `${dirServicePath}/dictionary/programmerWorkType`,

        }[category]),
    sqgl: category =>
        ({
            // 申请列表
            applyList: `${dirServicePath}/admin/user/applyList`,
            // 申请审核
            updateUserApply: `${dirServicePath}/admin/user/updateUserApply`,
            // 申请导出
            getUserApplyExcel: `${dirServicePath}/admin/user/getUserApplyExcel`
        }[category]),
    xtxx: category =>
        ({
            // 系统通知接口
            getMessageList: `${dirServicePath}/message/getMessageList`,
            // 读消息
            readMessage: `${dirServicePath}/message/readMessage`,
            // 删消息
            delMessage: `${dirServicePath}/message/deleteMessage`,
            //日历待办查询
            monthAnpai: `${dirServicePath}/backlog/monthAnpai`,
            //今日面试安排
            todayAnpai: `${dirServicePath}/backlog/todayAnpai`,
            //一键已读
            readAllMessage: `${dirServicePath}/message/readAllMessage`
        }[category]),
    zxgt: category =>
        ({
            // 聊天记录列表
            chatList: `${dirServicePath}/chat/chatList`,
            // 存聊天记录
            insertChat: `${dirServicePath}/chat/insertChat`,
            // 聊天记录详情
            getChat: `${dirServicePath}/chat/getChat`
        }[category]),
    zhgl: category =>
        ({
            //账号管理
            // 子账号列表
            chatList: `${dirServicePath}/user/getChildUser`,
            //创建子账号
            addUser: `${dirServicePath}/user/insertChildUser`,
            //禁用-启用
            updateChildUser: `${dirServicePath}/user/updateChildUser`,
            //重置密码
            resetChildUser: `${dirServicePath}/user/resetChildUser`,
            //删除子账号
            deleteChildUser: `${dirServicePath}/user/deleteChildUser`
        }[category]),
    qyqy: category =>
        ({
            //签约企业
            // 热门企业
            hotQiyeList: `${dirServicePath}/user/hotQiyeList`,
            //签约的企业列表
            getQiyeList: `${dirServicePath}/user/getQiyeList`,
            //为企业分配商务
            fenpeiQiye: `${dirServicePath}/user/fenpeiQiye`,
            //上传资质
            uploadUserQualification: `${dirServicePath}/userqualification/uploadUserQualification`,
            //查看资质模板
            getQiyeUserMould: `${dirServicePath}/usermould/getQiyeUserMould`,
            //查看已上传的资质
            getOwnUserQualification: `${dirServicePath}/userqualification/getOwnUserQualification`,
            //打包下载自己上传的资质
            packageOwnUserQualification: `${dirServicePath}/userqualification/packageOwnUserQualification`,
            //导出
            getQiyeExcel: `${dirServicePath}/user/getQiyeExcel`
        }[category]),
    kqgl: category =>
        ({
            //考勤管理
            // 考勤列表
            homeList: `${dirServicePath}/attendance/ruAttendance`,
            //审核考勤
            edit: `${dirServicePath}/attendance/ruUpdateAttendance`,
            //导出考勤
            checkout: `${dirServicePath}/attendance/gysAttendanceExcel`,
            //查看人员所有考勤
            staffAttendanceList: `${dirServicePath}/attendance/staffAttendanceList`,
            //一键同意考勤
            gysUpdateAllAttendance: `${dirServicePath}/attendance/gysUpdateAllAttendance`,
            //收入明细
            costList: `${dirServicePath}/cost//reward/costList`,
            //提现记录
            getWithdrawList: `${dirServicePath}/wallet/reward/getWithdrawList`,

            //提现获取验证码
            withdrawApplyCode: `${dirServicePath}/phonecode/withdrawApply`,
            //提现记录
            withdrawApplySub: `${dirServicePath}/wallet/reward/withdrawApply`
        }[category]),
    jsgl: category =>
        ({
            //结算管理
            //结算列表
            selectCostList: `${dirServicePath}/cost/selectCostList`,
            //上传盖章结算单
            uploadCostFile: `${dirServicePath}/cost/uploadCostFile`,
            //结算单明细
            costDetail: `${dirServicePath}/cost/costDetail`,
            //下载结算单
            downloadCostDetail: `${dirServicePath}/cost/downloadCostDetail`
        }[category]),
    fpgl: category =>
        ({
            //发票管理
            //列表
            selectCostInvoiceList: `${dirServicePath}/cost/invoice/selectCostInvoiceList`,
            //添加发票
            issueInvoice: `${dirServicePath}/cost/invoice/issueInvoice`,

            //上传发票图片
            uploadFile: `${dirServicePath}/cost/invoice/uploadFile`,
            //提交审核
            submit: `${dirServicePath}/cost/invoice/submit`,
            //填写快递信息
            setExpress: `${dirServicePath}/cost/invoice/setExpress`,
            // 查看开票信息
            invoicInfo: `${dirServicePath}/dictionary/invoicInfo`
        }[category]),
    rsgl: category =>
        ({
            //人事管理
            // 人事列表
            qiyeWorkDeliver: `${dirServicePath}/staff/gongyingshangStaffList`,
            // 离职
            lizhi: `${dirServicePath}/staff/lizhi`,
            // 供应商列表
            getWorkGongyingshang: `${dirServicePath}/staff/getWorkGongyingshang`,
            //模板导出
            getMould: `${dirServicePath}/staff/getMould`,
            //批量上传
            importStaff: `${dirServicePath}/staff/importStaff`,
            //评分列表
            staffGradeList: `${dirServicePath}/staffgrade/staffGradeList`,
            //批量上传
            setGrade: `${dirServicePath}/staffgrade/setGrade`,
            // 管家信息
            getGuanjia: `${dirServicePath}/dictionary/guanjia_p`,
        }[category]),
    personCenter: category =>
        ({
            // 钱包
            getWallet: `${dirServicePath}/wallet/programmer/getWallet`,
            // 绑定银行卡
            insertBankCard: `${dirServicePath}/bank/programmer/insertBankCard`,
            // 绑定银行卡获取验证码
            insertUserBankInfo: `${dirServicePath}/phonecode/insertUserBankInfo`,
            // 获取银行卡
            bankCardList: `${dirServicePath}/bank/programmer/bankCardList`,
            // 删除银行卡
            deleteBankCard: `${dirServicePath}/bank/programmer/deleteBankCard`,
            // 提现获取验证码
            withdrawApplyCode: `${dirServicePath}/phonecode/withdrawApply`,
            // 提现
            withdrawApply: `${dirServicePath}/wallet/programmer/withdrawApply`,
            // 提现
            withdrawApplyNew: `${dirServicePath}/wallet/programmer/withdrawApply`,
            // 提现详情
            walletRecordDetail: `${dirServicePath}/wallet/programmer/walletRecordDetail`,
            // 资金明细

            walletRecordList: `${dirServicePath}/wallet/programmer/walletRecordList`,

            // 订单列表
            programmerGetOrderList: `${dirServicePath}/workorder/programmer/getOrderList`,
            // 订单列表
            getOrderList: `${dirServicePath}/workorder/programmer/orderList`,
            // 订单详情
            getOrderDetail: `${dirServicePath}/workorder/programmer/getOrderDetail`,
            // // 终止订单
            // stopOrder: `${dirServicePath}/workorder/programmer/stopOrder`,

            // status = 3 6取消
            cancelOrder: `${dirServicePath}/workorder/programmer/cancelOrder`,
            // status = 8或9取消
            stopOrder: `${dirServicePath}/workorder/programmer/stopOrder`,
            // status = 8或9 提出确认
            finishOrder: `${dirServicePath}/workorder/programmer/finishOrder`,

            // 接受订单
            acceptOrder: `${dirServicePath}/workorder/programmer/acceptOrder`,
            // // 提出完成订单
            // finishOrder: `${dirServicePath}/workorder/programmer/finishOrder`,
            // 确认完成订单
            confirmFinishOrder: `${dirServicePath}/workorder/programmer/confirmFinishOrder`,
            // 确认取消订单
            confirmStopOrder: `${dirServicePath}/workorder/programmer/confirmStopOrder`,
            //评价
            rateOrder: `${dirServicePath}/workorder/programmer/rateOrder`,

            //个人中心信息
            programmerPersonalCenter: `${dirServicePath}/programmer/info/programmerPersonalCenter`,
            //已完成订单
            doneOrderList: `${dirServicePath}/workorder/programmer/doneOrderList`,
            //新订单详情
            orderDetail: `${dirServicePath}/workorder/programmer/orderDetail`,

            //获取是否可以删除/换绑
            preChange: `${dirServicePath}/bank/programmer/preChange`,

            //绑卡-账号校验获取验证码
            bindBankCardAuthStr: `${dirServicePath}/phonecode/programmer/bindBankCard/authStr`,
            //绑卡-验证验证码
            bindBankCardGetAuthStr: `${dirServicePath}/bank/programmer/bind/getAuthStr`,
            //绑卡
            bindBankCard: `${dirServicePath}/bank/programmer/bindBankCard`,

            //换绑-账号校验获取验证码
            changeBankCardAuthStr: `${dirServicePath}/phonecode/programmer/changeBankCard/authStr`,
            //换绑-验证验证码
            changeBankCardGetAuthStr: `${dirServicePath}/bank/programmer/change/getAuthStr`,
            //换绑
            changeBankCard: `${dirServicePath}/bank/programmer/changeBankCard`,

            //删除-账号校验获取验证码
            deleteBankCardAuthStr: `${dirServicePath}/phonecode/programmer/deleteBankCard/authStr`,
            //删除-验证验证码
            deleteBankCardGetAuthStr: `${dirServicePath}/bank/programmer/delete/getAuthStr`,
            //删除
            deleteBankCard: `${dirServicePath}/bank/programmer/deleteBankCard`,
        }[category]),
    useredit: category =>
        ({
            getInfo: `${dirServicePath}/programmer/info/getInfo`,
            getCompanyByToken: `${dirServicePath}/programmer/getProgrammerByToken`,
            updateInfo: `${dirServicePath}/programmer/info/updateInfo`,

            goGetAuthStr: `${dirServicePath}/phonecode/programmer/getAuthStr`, //旧手机验证码
            getAuthStr: `${dirServicePath}/programmer/getAuthStr`, //验证旧手机

            changePhone: `${dirServicePath}/phonecode/programmer/changePhone`,
            changePhones: `${dirServicePath}/programmer/changePhone`,

            submitInfo: `${dirServicePath}/programmer/info/submitInfo`, //个人信息（第一步）
            updateCVInfo: `${dirServicePath}/programmer/info/updateCVInfo`, //修改专业信息
            updateInfo: `${dirServicePath}/programmer/info/updateInfo`, //提交专业信息（第二步）

            getAuthWay: `${dirServicePath}/programmer/info/getAuthWay`, //获取可选的认证方式
            setAuthWay: `${dirServicePath}/programmer/info/setAuthWay`, //选择认证方式
        }[category]),
    clockIn: category =>
        ({
            // 当前工作
            presentWork: `${dirServicePath}/workrecord/programmer/presentWorkMp`,
            // 打卡
            punch: `${dirServicePath}/workrecord/programmer/punch`,
            // 申请补卡
            fillAttendance: `${dirServicePath}/workrecord/programmer/fillAttendance`,
            // 打卡记录
            presentWorkRecord: `${dirServicePath}/workrecord/programmer/presentWorkRecord`,

            // 申请列表
            approvalList: `${dirServicePath}/approval/programmer/approvalList`,
            // 补卡详情
            getFill: `${dirServicePath}/workrecord/programmer/getFill`,
            // 加班详情
            getWorkOver: `${dirServicePath}/workrecord/programmer/getWorkOver`,
            // 加班申请
            workOverApproval: `${dirServicePath}/workrecord/programmer/workOverApproval`,
            // 请假详情
            getWorkLeave: `${dirServicePath}/workrecord/programmer/getWorkLeave`,
            // 报销详情
            getWorkReimbursement: `${dirServicePath}/workrecord/programmer/getWorkReimbursement`,
            //合同签署
            createFlowOneStep: `${dirServicePath}/programmer/info/createFlowOneStep`,

        }[category]),
    account: category =>
        ({
            // 订单列表
            orderList: `${dirServicePath}/workorder/company/getOrderList`,
            getRule: `${dirServicePath}/attendanceRule/getRule`,
            setRule: `${dirServicePath}/attendanceRule/setRule`,
            getStaffWorkRecordList: `${dirServicePath}/workrecord/company/getStaffWorkRecordList`,
            staffWorkRecordByMonth: `${dirServicePath}/workrecord/company/staffWorkRecordByMonth`,
            workStaffList: `${dirServicePath}/workstaff/company/workStaffList`,

            rateOrder: `${dirServicePath}/workorder/company/rateOrder`,

            getAttendanceList: `${dirServicePath}/attendance/programmer/getAttendanceList`,
            readAttendance: `${dirServicePath}/attendance/programmer/readAttendance`
        }[category]),
    message: category =>
        ({
            //通知列表
            noticeList: `${dirServicePath}/notice/programmer/noticeList`,
            read: `${dirServicePath}/notice/programmer/read`, //读消息
            readAll: `${dirServicePath}/notice/programmer/readAll`, //一键读消息
        }[category]),
};
export default serverUrl;


// WEBPACK FOOTER //
// ./src/js/server-config.js